module.exports = __webpack_public_path__ + "images/h5-top-light.02e1fd20.png";